var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkAngleRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.676 12.01-1.02 1.02a3.314 3.314 0 0 1-4.685 0v0a3.314 3.314 0 0 1 0-4.687L4.3 7.013a3.333 3.333 0 0 1 4.714 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.323 3.99 1.02-1.02a3.314 3.314 0 0 1 4.686 0v0a3.314 3.314 0 0 1 0 4.687L11.7 8.987a3.333 3.333 0 0 1-4.714 0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkAngleRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LinkAngleRight.84605e28.svg";
export { ForwardRef as ReactComponent };